module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07519_logo_200x200.206ab824.png";